import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { PracticeService } from 'src/app/services/practice.service';
import { UserRolesService } from 'src/app/services/user-roles.service';

@Component({
  selector: 'app-invite-member',
  templateUrl: './invite-member.component.html',
  styleUrls: ['./invite-member.component.scss']
})
export class InviteMemberComponent implements OnInit {
  public email:string;
  public showExtra:boolean=false;
  public inviteError = null;
  public firstName:string='';
  public lastName:string='';
  public role:string='';
  public roles=[];

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _notify: NotificationService,
    private _practice: PracticeService,
    private _roles: UserRolesService
  ) {
    this._roles.getPaginatedUserRoles(1, 100).subscribe(res=>{
      this.roles=res.data;
    });
  }

  ngOnInit() {
  }

  public register(){
    this.inviteError=null;
    if(!this.email){
      return this.inviteError='Please provide an Email';
    }
    if(!this.firstName){
      return this.inviteError='Please provide a First Name';
    }
    if(!this.lastName){
      return this.inviteError='Please provide a Last Name';
    }
    if(this.role==''){
      return this.inviteError='Please provide a Job Role';
    }
    this.inviteError=null;
    this._practice.registerInviteMember(
      this.email,
      this.firstName,
      this.lastName,
      this.role,
      this.data.practice.id
    ).subscribe(res=>{
      this.dialogRef.close(true);
    });
  }

  submit() {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(this.email)){
      this._practice.inviteUser(this.data.practice.id, this.email).subscribe(
        (res:any)=>{
          if(res.showExtra){
            this.showExtra=true;
            this.inviteError='This user is not currently a member of Central CPD On-Demand, please add their details below to register them.';
            return;
          }
          if(res.message) return this._notify.showMessage(res.message, 'OK');
          this.dialogRef.close(true);
        }
      );
    } else {
      this._notify.showMessage('Please enter a valid email address.', 'OK');
    }
  }

  cancel(){
    this.email='';
    this.dialogRef.close(false);
  }

}
